import { Button } from "@heroui/react";
import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

const AlertFailed = ({ text, apiText, notif }) => {
    return (
        <div
            className={
                notif
                    ? "fixed top-0 left-0 z-40 w-full h-screen bg-opacity-95 backdrop-blur-lg bg-white_m-200 dark:bg-black_m-400/80"
                    : "hidden"
            }
        >
            <div className="flex flex-col w-full h-full justify-around items-center">
                <h2 className="font-semibold text-3xl my-4">Ooops!</h2>
                <div className="relative mb-8">
                    <span className="animate-ping absolute left-4 top-4 inline-flex h-16 w-16 rounded-full bg-orange_m-100 opacity-75"></span>
                    <div className="flex relative text-5xl text-white_m-200 justify-center items-center h-24 w-24 bg-orange_m-100 rounded-full">
                        <IoCloseOutline />
                    </div>
                </div>
                <div className="bg-white p-2 rounded-2xl shadow-xl">
                    <p className="text-center text-md dark:text-black_m-400 font-semibold">
                        {apiText}
                    </p>
                    <p style={{ whiteSpace: "pre-line" }} className="text-sm text-black_m-300 mb-5 text-center p-4">
                        {text}
                    </p>
                </div>
                <Button
                    onPress={() => notif(null)}
                    className="w-72 bg-orange_m-100 text-white_m-200 text-1xl rounded-2xl shadow-lg"
                >
                    Kembali
                </Button>
            </div>
        </div>
    );
};

export default AlertFailed;
